import React, { useEffect, useRef } from 'react';
import './style.scss'

import { useField } from '@unform/core';

function Input({ name, col, groupClass='', hidden, ...props }) {
    const inputRef = useRef(null);
    const { fieldName, defaultValue, registerField, error } = useField(name);

    useEffect(() => {
        registerField({
            name: fieldName,
            ref: inputRef.current,
            path: 'value',
        });
    }, [fieldName, registerField]);

    return (
        <div className={`cInputD ${col} ${error && 'validacao-error'}`} style={{ display: `${hidden ? 'none' : ''}` }}>
            <span>{props.titulo}</span>
            <div className={`input-group input-group-merge input-group-alternative ${groupClass}`}>
                <input id={name} autoComplete='off' ref={inputRef} defaultValue={defaultValue} {...props} />
            </div>
            {error && <span className="error-validacao">{error}</span>}
        </div>
    );
}

export default Input